import styled from 'styled-components';

export const Root = styled.div`
  position: relative;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`

export const TextBox = styled.div`
  position: absolute;
  margin-top: 2px;
  left: -30px;
  right: -30px;
  text-align: center;
  justify-content: center;
  max-height: 0px;
  opacity: 0;
  transition: opacity 0.2s, max-height 0s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  z-index: 60;
  ${Root}:hover & {
    display: flex;
    opacity: 1;
    max-height: 500px;
    transition-delay: 0.5s;
  }
`

export const TextTitle = styled.div`
  color: white;
  padding: 6px 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: pre-line;
  background-color: #525252;
`